import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';

const EditarSala = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [sala, setSala] = useState(null);
  const [selectedColor, setSelectedColor] = useState('#000000');

  useEffect(() => {
    const fetchSala = async () => {
      try {
        const response = await authFetch(`room/${id}`);
        if (!response.ok) throw new Error('Erro ao carregar sala');
        const data = await response.json();
        setSala(data);
        setSelectedColor(data.color);
      } catch (error) {
        showNotification('danger', 'Erro ao carregar sala');
        navigate('/Salas');
      }
    };

    fetchSala();
  }, [id, navigate, showNotification]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData(event.target);
      const data = {
        id: parseInt(id),
        name: formData.get('name'),
        color: formData.get('color')
      };

      const response = await authFetch('room', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) throw new Error('Erro ao atualizar sala');

      showNotification('success', 'Sala atualizada com sucesso!');
      navigate('/Salas');
    } catch (error) {
      showNotification('danger', 'Erro ao atualizar sala');
    } finally {
      setLoading(false);
    }
  };

  if (!sala) return null;

  return (
    <div className="content">
      <h3 className="font-weight-bolder mb-3">Editar Sala</h3>
      <div className="card">
        <div className="card-body p-3">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Nome</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                defaultValue={sala.name}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="color" className="form-label">Cor</label>
              <div className="d-flex align-items-center gap-3">
                <input
                  type="color"
                  className="form-control form-control-color"
                  id="color"
                  name="color"
                  value={selectedColor}
                  onChange={(e) => setSelectedColor(e.target.value)}
                  style={{
                    width: '50px',
                    height: '50px',
                    padding: '2px'
                  }}
                  required
                />
                <div 
                  className="rounded-circle border"
                  style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: selectedColor
                  }}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate('/Salas')}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditarSala; 